// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.q6Mrc{display:flex;flex-direction:column;min-height:100%;padding-bottom:16px;box-sizing:border-box;justify-content:flex-end}.q6Mrc .rpv-core__viewer{display:flex;flex-direction:column;flex:1;min-height:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pdfViewerWrapper": `q6Mrc`
};
export default ___CSS_LOADER_EXPORT___;
